import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function fileUrl(id) {
  if (!id) return null;
  if (typeof id === "string" && (id.startsWith("http://") || id.startsWith("https://"))) return id;
  return `${API_BASE}/files/${id}`;
}
